var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBridge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 9.15789C21 11.7195 19.4359 13.9159 17.2105 14.8438V14.8421C17.2105 10.3948 13.6052 6.78947 9.1579 6.78947H9.15616C10.0842 4.56415 12.2805 3 14.8421 3C18.2431 3 21 5.75698 21 9.15789ZM7.26316 3.47368C5.17029 3.47368 3.47368 5.17029 3.47368 7.26316V8.68421H5.36842V7.26316C5.36842 6.21672 6.21672 5.36842 7.26316 5.36842H8.68421V3.47368H7.26316ZM18.6316 15.3158V16.7368C18.6316 17.7833 17.7833 18.6316 16.7368 18.6316H15.3158V20.5263H16.7368C18.8297 20.5263 20.5263 18.8297 20.5263 16.7368V15.3158H18.6316ZM9.15789 21C12.5589 21 15.3158 18.2431 15.3158 14.8421C15.3158 11.4411 12.5589 8.68421 9.15789 8.68421C5.75698 8.68421 3 11.4411 3 14.8421C3 18.2431 5.75698 21 9.15789 21ZM9.15789 12.4737L11.5263 14.8421L9.15789 17.2105L6.78947 14.8421L9.15789 12.4737Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBridge);
export default __webpack_public_path__ + "static/media/icon-bridge.6d30ca64afc5ba827d7e7760749d350a.svg";
export { ForwardRef as ReactComponent };